export default __webpack_public_path__ + "static/media/1877.16b20c9b.png";